import { Controller } from '@hotwired/stimulus'

// Count a number up from zero when its panel appears.
//
//   <span class="ui-kpi__value" data-controller="count-up">1234</span>
//
// The final value is the element's own text, so the page is correct without
// JS and screen readers / copy-paste see the real number. Anything that is
// not a plain number (a word, a week label) is left alone, and a viewer who
// asked for less motion gets the number straight away.
export default class extends Controller {
  connect () {
    const raw = (this.element.textContent || '').trim()
    const m = raw.match(/^-?\d+(?:[.,]\d+)?$/)
    if (!m) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    const decimals = (raw.split(/[.,]/)[1] || '').length
    const sep = raw.includes(',') ? ',' : '.'
    const target = parseFloat(raw.replace(',', '.'))
    if (!isFinite(target)) return
    // Een kaal geheel getal onder de 2 optellen oogt onnozel (0 → 1). Met
    // decimalen is er wél iets te zien: 0,00 → 0,32 telt zichtbaar op, en dat
    // zijn precies de smoothing-constanten en foutpercentages op de Forecaster.
    if (!decimals && Math.abs(target) < 2) return

    const duration = 700
    const start = performance.now()
    const render = (v) => {
      const txt = decimals ? v.toFixed(decimals).replace('.', sep) : String(Math.round(v))
      this.element.textContent = txt
      this.lastWritten = txt
    }
    const step = (now) => {
      // Sommige van deze getallen worden tijdens het fitten live bijgewerkt
      // (de Forecaster schrijft de smoothing-constanten weg terwijl hij
      // rekent). Staat er iets anders dan wat wij er als laatste neerzetten,
      // dan heeft iemand anders het overschreven: stoppen en het met rust
      // laten, anders tellen we naar een waarde die niet meer klopt.
      if (this.element.textContent !== this.lastWritten) { this.original = null; return }
      const p = Math.min(1, (now - start) / duration)
      // easeOutQuart — fast off the mark, settles on the real value.
      render(target * (1 - Math.pow(1 - p, 4)))
      if (p < 1) {
        this.frame = requestAnimationFrame(step)
      } else {
        this.element.textContent = raw
        this.lastWritten = raw
        // Klaar: niets meer te herstellen bij disconnect. Zou `original`
        // blijven staan, dan draaide een latere live-update terug naar oud.
        this.original = null
        this.frame = null
      }
    }
    render(0)
    this.frame = requestAnimationFrame(step)
    this.original = raw
  }

  disconnect () {
    if (this.frame) cancelAnimationFrame(this.frame)
    // Alleen herstellen als we midden in de animatie zijn afgebroken; dan
    // staat er een tussenwaarde op het scherm.
    if (this.frame && this.original) this.element.textContent = this.original
    this.frame = null
    this.original = null
  }
}
